module.exports = __webpack_public_path__ + "img/PNMT_Card.6e4431ab.svg";